import { LogLevel, type Configuration } from "@azure/msal-browser";

const splitList = (value?: string): string[] =>
  (value ?? "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

const getMsalConfig = (): Configuration => {
  const {
    VITE_MSAL_CLIENT_ID,
    VITE_MSAL_AUTHORITY,
    VITE_MSAL_KNOWN_AUTHORITIES,
    VITE_MSAL_REDIRECT_URI,
  } = import.meta.env;

  return {
    auth: {
      clientId: VITE_MSAL_CLIENT_ID,
      authority: VITE_MSAL_AUTHORITY,
      redirectUri: VITE_MSAL_REDIRECT_URI || window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      knownAuthorities: splitList(VITE_MSAL_KNOWN_AUTHORITIES),
    },
    cache: {
      cacheLocation: "localStorage",
    },
    system: {
      loggerOptions: {
        loggerCallback: (
          level: LogLevel,
          message: string,
          containsPii: boolean,
        ): void => {
          void message;
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              return;
            case LogLevel.Warning:
              return;
            case LogLevel.Info:
              return;
            case LogLevel.Verbose:
              return;
          }
        },
      },
    },
  };
};

export const msalConfig = getMsalConfig();

// openid - Authenticate user
// offline_access - Get refresh token
// api/Tasks.Read - Authorize API access
export const loginRequest = {
  scopes: ["openid", "offline_access", import.meta.env.VITE_API_READ_URL],
};

export const passwordResetRequest = {
  authority: import.meta.env.VITE_PASSWORD_RESET_URL,
  scopes: [],
};
